var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-autocomplete", {
    staticStyle: { width: "100%" },
    attrs: {
      "popper-class": "my-autocomplete",
      disabled: _vm.disabled,
      type: "textarea",
      rows: 3,
      "fetch-suggestions": _vm.querySearch,
      placeholder: _vm.placeholder,
      clearable: _vm.clearable,
    },
    on: { change: _vm.handleChange, select: _vm.handleSelect },
    scopedSlots: _vm._u(
      [
        {
          key: "default",
          fn: function (ref) {
            var item = ref.item
            return item
              ? [
                  _c(
                    "div",
                    {
                      class: [
                        "name",
                        _vm.state.includes(item.value) ? "selected" : "",
                      ],
                    },
                    [_vm._v(_vm._s(item.value))]
                  ),
                ]
              : undefined
          },
        },
      ],
      null,
      true
    ),
    model: {
      value: _vm.state,
      callback: function ($$v) {
        _vm.state = $$v
      },
      expression: "state",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }